<script>
	import Alert from "./Alert.svelte";

	export let text;
</script>

<Alert alertClass="error" iconName="ban" {text} />
